import axios from "@/utils/http"  //获取封装的axios
import { Message } from "element-ui"; //调用element-ui 的message功能

export default{
    namespaced:true,
    state:{
        infoByPageList:[],
        infoByPageToTal:0,
        pageInfo:{
            pageNum:1,
            pageSize:15,
            mainTitle:null,
            type:null,
            beginTime:null,
            endTime:null
        },
    },
    mutations:{
        //数据处理,将token放在本地存储里面
        // 获取分页数据
        getInfoByPageList(state,list){
            state.infoByPageList = list
        },
        // 获取分页总数
        getInfoByPageToTal(state,total){
            state.infoByPageToTal = total
        },
    },
    actions:{
        //获取分页信息的接口调用
        getInfoBypageAction({commit},state){
            axios.post('/article/page',state).then(response =>{
                if (response.code === 200) {
                    commit('getInfoByPageList',response.data.records)
                    commit('getInfoByPageToTal',response.data.total)
                    Message({
                        message:response.message,
                        type:'success'
                    })
                }else{
                    Message({
                        message:response.message,
                        type:'error'
                    })
                }
            })
        },
        // 新增
        postAddDate({ dispatch,state },formInline){
            axios.post('/article/add',formInline).then(response =>{
                if (response.code === 200) {
                    dispatch('getInfoBypageAction',state.pageInfo)
                }else{
                    Message({
                        message:response.message,
                        type:'error'
                    })
                }
            })
        },
        // 编辑
        editDate({dispatch,state},form){
            axios.post('/article/update',form).then(response =>{
                if (response.code === 200) {
                    dispatch('getInfoBypageAction',state.pageInfo)
                }else{
                    Message({
                        message:response.message,
                        type:'error'
                    })
                }
            })
        },
        // 逻辑删除
        delAction({dispatch,state},ids){
            axios.post('/article/delete',ids).then(response =>{
                if (response.code === 200) {
                    dispatch('getInfoBypageAction',state.pageInfo)
                }else{
                    Message({
                        message:response.message,
                        type:'error'
                    })
                }
            })
        }
    },
    getters:{

    }
}